import { bg_emphasis } from "@clockwise/design-system/tokens";
import { Tooltip as MuiTooltip, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import * as React from "react";

const StyledTooltip = (maxWidth: number, styles?: Record<string, string>) =>
  withStyles(() => ({
    arrow: { color: bg_emphasis },
    tooltip: {
      backgroundColor: bg_emphasis,
      fontSize: 12,
      padding: 10,
      borderRadius: 5,
      maxWidth: maxWidth,
      ...styles,
    },
  }))(MuiTooltip);

// Remove default styling from link tags
const useStyles = makeStyles({
  body: {
    "& a": {
      textDecoration: "none",
      color: "white",
    },
  },
});

interface TooltipBodyProps {
  header?: string;
  body?: string;
}
const ToolTipBody = ({ body, header }: TooltipBodyProps) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {!!header && <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 3 }}> {header} </div>}
      <div className={classes.body} dangerouslySetInnerHTML={{ __html: body ?? "" }} />
    </React.Fragment>
  );
};

export interface TooltipProps {
  children: React.ReactNode;
  header?: string;
  body: string;
  width?: number;
  placement: "top" | "left" | "right" | "bottom";
  showArrow: boolean;
  styles?: Record<string, string>;
  className?: string;
}

export const Tooltip = ({
  children,
  header,
  body,
  width,
  placement,
  showArrow,
  styles,
  className,
}: TooltipProps) => {
  const styleProps = styles ? styles : {};
  const StyledTooltipWithWidth = StyledTooltip(width || 300, styleProps);

  if (!header && !body) {
    return <>{children}</>; // Don't render tooltip if there is no header or body
  }

  return (
    <StyledTooltipWithWidth
      title={<ToolTipBody header={header} body={body} />}
      placement={placement}
      arrow={showArrow}
    >
      <div className={classNames(className)}> {children} </div>
    </StyledTooltipWithWidth>
  );
};
